import { render, staticRenderFns } from "./lookMember.vue?vue&type=template&id=4b7f08e8&scoped=true&"
import script from "./lookMember.vue?vue&type=script&lang=js&"
export * from "./lookMember.vue?vue&type=script&lang=js&"
import style0 from "./lookMember.vue?vue&type=style&index=0&id=4b7f08e8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7f08e8",
  null
  
)

export default component.exports